import { render, staticRenderFns } from "./anchor-link.vue?vue&type=template&id=6524aed0"
import script from "./anchor-link.vue?vue&type=script&lang=js"
export * from "./anchor-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports